import {
  FontAwesomeIcon,
  type FontAwesomeIconProps
} from '@fortawesome/react-fontawesome'
import { headerIcon } from './Header.css'

export const HeaderIcon = (props: FontAwesomeIconProps) => (
  <div className={headerIcon}>
    <FontAwesomeIcon {...props} />
  </div>
)
